import { render, staticRenderFns } from "./SoldEvents.vue?vue&type=template&id=5479b33c&scoped=true"
import script from "./SoldEvents.vue?vue&type=script&lang=js"
export * from "./SoldEvents.vue?vue&type=script&lang=js"
import style0 from "./SoldEvents.vue?vue&type=style&index=0&id=5479b33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479b33c",
  null
  
)

export default component.exports